/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { useEffect, useMemo, useRef, useState } from "react";
import CancelIcon from "@Assets/icons/svg/Cancel.svg?react";
import UpdateIcon from "@Assets/icons/svg/Update.svg?react";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, MenuItem, Select } from "@mui/material";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR } from "@Services/constants";
import { ObjectId } from "bson";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { useTranslation } from "@i18n";
import DownArrowIcon from "@Assets/icons/svg/arrowDown.svg?react";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { DependencyProps } from "../interface";
import Text from "@CubeComponents/html/Text/Text";

function DependencyInGantt(props: Readonly<DependencyProps>) {
  const { t } = useTranslation();
  const {
    currentTab,
    gantt,
    currentSelectedTask,
    deletedLinks,
    setDeletedLinks,
    dependencyAddEditData,
    setDependencyAddEditData,
    hoursPerDay,
  } = props;

  const [dependencyDataset, setDependencyDataset] = useState<any>([]);
  const [dependencyEditMode, setDependencyEditMode] = useState(false);
  const [dependencyEditItemsData, setDependencyEditItemsData] = useState<any>({});
  const [disableEditInDependency, setDisableEditInDependency] = useState(true);
  const [disableDeleteInDependency, setDisableDeleteInDependency] = useState(true);
  const [disableAddInDependency, setDisableAddInDependency] = useState(false);
  const [editClicked, setEditClicked] = useState(false);

  const reactGridRef = useRef<any>(null);
  const dispatch = useDispatch();
  const { GanttDetails } = useSelector((state): any => state);
  const slickGridOptions = useMemo(
    () => ({
      forceFitColumns: true,
      enableGridMenu: false,
      enableFiltering: false,
      enableCellMenu: false,
      enableHeaderMenu: false,
    }),
    [],
  );
  const getDependencyType: any = {
    0: "Finish - Start",
    1: "Start - Start",
    2: "Finish - Finish",
    3: "Start - Finish",
  };

  const getTaskDependency = () => {
    const selectedId = gantt.getSelectedId();
    const task = gantt.getTask(selectedId);

    if (!selectedId) {
      return {
        predecessor: [],
        successor: [],
        allDependency: [],
      };
    }
    const predecessor = (task.$target || []).map((linkId: any) => {
      const link = gantt.getLink(linkId);
      const predecessorTask = gantt.getTask(link.source);
      return {
        id: linkId,
        TaskDisp: predecessorTask.TaskDisp,
        name: predecessorTask.text,
        type: link.type,
        lag: GanttDetails.config?.duration_unit === "hour" ? Math.ceil((link.lag ?? 0) / hoursPerDay) : (link.lag ?? 0),
        predId: link.source,
        linkType: "Predecessor",
      };
    });
    const successor = (task.$source || []).map((linkId: any) => {
      const link = gantt.getLink(linkId);
      const succesorTask = gantt.getTask(link.target);
      return {
        id: link.id,
        TaskDisp: succesorTask.TaskDisp,
        name: succesorTask.text,
        type: link.type,
        lag: GanttDetails.config?.duration_unit === "hour" ? Math.ceil((link.lag ?? 0) / hoursPerDay) : (link.lag ?? 0),
        successorId: link.target,
        linkType: "Successor",
      };
    });

    const allDependency = [...predecessor, ...successor];

    return {
      predecessor,
      successor,
      allDependency,
    };
  };

  const getFiltredItems = () => {
    const allTasks = gantt.getTaskByTime();
    let attachedTasks: any = getTaskDependency();
    attachedTasks = [...attachedTasks.allDependency, ...dependencyAddEditData];
    return allTasks.filter(
      (task) =>
        task.TaskDisp !== currentSelectedTask.TaskDisp &&
        !attachedTasks.some((datasetItem: any) => datasetItem.TaskDisp === task.TaskDisp),
    );
  };
  const handleDependencyFields = (field: string, value: any) => {
    const tempFields: any = { ...dependencyEditItemsData, [field]: value };
    if (field === "TaskDisp" || field === "name") {
      const matchedTasks: any = gantt
        .getTaskByTime()
        .find((task: any) => task[field == "name" ? "text" : field] === value);
      if (matchedTasks) {
        Object.assign(tempFields, {
          TaskDisp: matchedTasks.TaskDisp,
          name: matchedTasks.text,
          id: new ObjectId().toString(),
          type: tempFields.type || "0",
          lag: tempFields.lag || 0,
        });
      }
      if (currentTab == "Predecessor") {
        tempFields.predId = matchedTasks.id;
        tempFields.linkType = "Predecessor";
      } else if (currentTab == "Successor") {
        tempFields.successorId = matchedTasks.id;
        tempFields.linkType = "Successor";
      }
    }
    setDependencyEditItemsData(tempFields);
  };
  const dependencyIdEditorTemplate = () => {
    const dropdownItems = getFiltredItems();
    if (editClicked) {
      dropdownItems.push(dependencyEditItemsData);
    }
    return (
      <div>
        <FormControl
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: "2rem",
              width: "9.375rem",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#666A84",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#6BBBE3",
              borderWidth: "0.0625rem",
            },
          }}
        >
          <Select
            IconComponent={DownArrowIcon}
            onChange={(e) => handleDependencyFields("TaskDisp", e.target.value)}
            value={dependencyEditItemsData.TaskDisp}
            disabled={editClicked}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: "16.25rem",
                  overflow: "auto",
                  maxWidth: "9.375rem",
                },
              },
              MenuListProps: {
                sx: {
                  py: 0,
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "2rem",
                py: 0,
              },
              "& .MuiSelect-icon": {
                top: "50%",
                transform: "translateY(-50%)",
                width: "1rem",
                height: "1rem",
              },
            }}
          >
            {dropdownItems.map((item: any) => (
              <MenuItem
                key={item.TaskDisp}
                value={item.TaskDisp}
                sx={{
                  borderBottom: "0.125rem solid #ECF3FE",
                  height: "3rem",
                  display: "flex",
                  alignItems: "center",
                  color: "#192048",
                }}
              >
                {item.TaskDisp}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const dependencyNameEditorTemplate = () => {
    const dropdownItems = getFiltredItems();
    if (editClicked) {
      dropdownItems.push(dependencyEditItemsData);
    }
    return (
      <div>
        <FormControl
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: "2rem",
              width: "9.375rem",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#666A84",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#6BBBE3",
              borderWidth: "0.0625rem",
            },
          }}
        >
          <Select
            IconComponent={DownArrowIcon}
            onChange={(e) => handleDependencyFields("name", e.target.value)}
            value={dependencyEditItemsData.name}
            disabled={editClicked}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: "16.25rem",
                  overflow: "auto",
                  maxWidth: "9.375rem",
                },
              },
              MenuListProps: {
                sx: {
                  py: 0,
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "2rem",
                py: 0,
              },
              "& .MuiSelect-icon": {
                top: "50%",
                transform: "translateY(-50%)",
                width: "1rem",
                height: "1rem",
              },
            }}
          >
            {dropdownItems.map((item: any) => {
              return (
                <MenuItem
                  value={item.text}
                  key={item.TaskDisp}
                  sx={{
                    borderBottom: "0.125rem solid #ECF3FE",
                    height: "3rem",
                    display: "flex",
                    alignItems: "center",
                    color: "#192048",
                  }}
                >
                  {item.text}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    );
  };
  const dependencyTypeEditorTemplate = () => {
    return (
      <div>
        <FormControl
          fullWidth
          sx={{
            "& .MuiInputBase-root": {
              height: "2rem",
              width: "9.375rem",
              backgroundColor: "white",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#666A84",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#6BBBE3",
              borderWidth: "0.0625rem",
            },
          }}
        >
          <Select
            IconComponent={DownArrowIcon}
            onChange={(e) => handleDependencyFields("type", e.target.value)}
            value={dependencyEditItemsData.type || "0"}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: "16.25rem",
                  overflowY: "auto",
                },
              },
              MenuListProps: {
                sx: {
                  py: 0,
                },
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "2rem",
                py: 0,
              },
              "& .MuiSelect-icon": {
                top: "50%",
                transform: "translateY(-50%)",
                width: "1rem",
                height: "1rem",
              },
            }}
          >
            <MenuItem
              value="0"
              sx={{
                borderBottom: "0.125rem solid #ECF3FE",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                color: "#192048",
              }}
            >
              <Text>{t("Finish - Start")}</Text>
            </MenuItem>
            <MenuItem
              value="1"
              sx={{
                borderBottom: "0.125rem solid #ECF3FE",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                color: "#192048",
              }}
            >
              <Text>{t("Start - Start")}</Text>
            </MenuItem>
            <MenuItem
              value="2"
              sx={{
                borderBottom: "0.125rem solid #ECF3FE",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                color: "#192048",
              }}
            >
              <Text>{t("Finish - Finish")}</Text>
            </MenuItem>
            <MenuItem
              value="3"
              sx={{
                borderBottom: "0.125rem solid #ECF3FE",
                height: "3rem",
                display: "flex",
                alignItems: "center",
                color: "#192048",
              }}
            >
              <Text>{t("Start - Finish")}</Text>
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    );
  };
  const dependencyLagEditorTemplate = (args: any) => {
    return (
      <div>
        <TextFieldComponent
          onChange={(e) => handleDependencyFields("lag", e.target.value)}
          type="number"
          defaultValue={args.args.lag || 0}
        />
      </div>
    );
  };

  const typeTemplate = (_row: number, _cell: number, _value: any) => {
    const container = document.createElement("div");
    const root = createRoot(container);
    root.render(<div>{getDependencyType[_value]}</div>);
    return container;
  };

  const gridColumns = useMemo(
    () => [
      {
        field: "TaskDisp",
        id: "TaskDisp",
        width: 40,
        textAlign: "Left",
        sortable: true,
        name: t("ID"),
        editorTemplate: dependencyIdEditorTemplate,
      },
      {
        field: "name",
        id: "name",
        width: 50,
        textAlign: "Left",
        sortable: true,
        name: t("Name"),
        editorTemplate: dependencyNameEditorTemplate,
      },
      {
        field: "type",
        id: "type",
        width: 10,
        textAlign: "Left",
        sortable: true,
        name: t("Type"),
        editorTemplate: dependencyTypeEditorTemplate,
        formatter: typeTemplate,
      },
      {
        field: "lag",
        id: "lag",
        width: 10,
        textAlign: "Left",
        sortable: true,
        name: t("Offset"),
        editorTemplate: dependencyLagEditorTemplate,
      },
    ],

    [dependencyEditItemsData.TaskDisp, dependencyEditItemsData.name, dependencyEditItemsData.type, currentTab],
  );

  useEffect(() => {
    const dependency: any = getTaskDependency();
    if (currentTab == "Predecessor" || currentTab == "Successor") {
      const deletedIds = new Set((deletedLinks ?? []).map((link: any) => link.id?.toString()));
      const tempArray: any[] = dependencyAddEditData.filter(
        (link: any) => link.linkType == currentTab && !deletedIds.has(link.id?.toString()),
      );
      const ganttRows: any[] = currentTab == "Predecessor" ? dependency.predecessor : dependency.successor;
      const editedIds = new Set(tempArray.map((link: any) => link.id?.toString()));
      const filteredGanttRows = ganttRows.filter((row: any) => {
        const rowId = row.id?.toString();
        return !editedIds.has(rowId) && !deletedIds.has(rowId);
      });
      setDependencyDataset([...filteredGanttRows, ...tempArray]);
    }
    setDependencyEditMode(false);
    setDependencyEditItemsData({});
    setEditClicked(false);
    setDisableEditInDependency(true);
    setDisableDeleteInDependency(true);
    setDisableAddInDependency(false);
  }, [currentTab]);

  const setEmptySelectedRows = () => {
    if (reactGridRef.current) {
      reactGridRef.current.dataView.selectedRowIds = [];
      reactGridRef.current.slickGrid.setSelectedRows([]);
      reactGridRef.current.dataView.setSelectedIds([]);
    }
  };

  const handleAddClick = () => {
    const links = reactGridRef.current.dataView.items;
    const newRow = {
      id: new ObjectId().toString(),
      TaskDisp: "",
      name: "",
      type: "0",
      lag: 0,
      predId: "",
    };
    const updatedLinks = [newRow, ...links];
    setDependencyDataset(updatedLinks);
    setDependencyEditMode(true);
    setTimeout(() => {
      if (reactGridRef.current?.slickGrid) {
        reactGridRef.current.slickGrid.setSelectedRows([0]);
      }
    }, 0);
  };
  const handleEditClick = () => {
    const selectedRows = reactGridRef.current?.slickGrid?.getSelectedRows();
    if (!selectedRows?.length) return;
    const selectedRowdData = reactGridRef.current.dataView.items[selectedRows[0]];
    if (!selectedRowdData) return;
    selectedRowdData.text = selectedRowdData.name;
    setDependencyEditItemsData(selectedRowdData);
    setDependencyEditMode(true);
    setEditClicked(true);
  };
  const handleUpdateClick = () => {
    if (dependencyEditItemsData.TaskDisp) {
      const editedId = dependencyEditItemsData.id?.toString();
      setDependencyAddEditData([
        ...dependencyAddEditData.filter((link: any) => link.id?.toString() !== editedId),
        { ...dependencyEditItemsData },
      ]);
      reactGridRef.current.dataView.items[reactGridRef.current.slickGrid.getSelectedRows()[0]] =
        dependencyEditItemsData;
      reactGridRef.current.dataView.setItems(reactGridRef.current.dataView.items);
      setDependencyEditItemsData({});
      setEditClicked(false);
      setDisableEditInDependency(true);
      setDependencyEditMode(false);
      setEmptySelectedRows();
    } else {
      dispatch(
        showToastNotification({
          content: t("Please select a task"),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };
  const handleCancelClick = () => {
    setDependencyEditMode(false);
    if (!editClicked) {
      const remainingItems = reactGridRef.current.dataView.items.slice(1);
      reactGridRef.current.dataView.setItems(remainingItems);
      setDependencyDataset(remainingItems);
    }
    setEmptySelectedRows();
    setDisableEditInDependency(true);
    setDisableAddInDependency(false);
    setEditClicked(false);
    setDisableDeleteInDependency(true);
    setDependencyEditItemsData({});
  };
  const handleDeleteClick = () => {
    const selectedRows = reactGridRef.current.slickGrid.getSelectedRows();
    const selectedItems = selectedRows.map((row: number) => reactGridRef.current.dataView.items[row]);
    const allItems = reactGridRef.current.dataView.items;
    const updatedItems = allItems.filter(
      (item: any, index: number) => !selectedRows.some((row: number) => row == index),
    );
    const removedIds = new Set(selectedItems.map((item: any) => item.id?.toString()));
    setDeletedLinks([...deletedLinks, ...selectedItems]);
    setDependencyAddEditData(dependencyAddEditData.filter((link: any) => !removedIds.has(link.id?.toString())));
    setDependencyDataset(updatedItems);
    setEmptySelectedRows();
  };
  const toolbar = useMemo(
    () => [
      {
        name: t("Add"),
        id: "add",
        prefixIcon: "add",
        cssClass: "font-semibold text-sm",
        buttonType: BUTTON_TYPES.BACKGROUND_BUTTON,
        disabled: disableAddInDependency || dependencyEditMode,
      },
      {
        name: t("Edit"),
        id: "edit",
        prefixIcon: "EditIcon",
        cssClass: "font-semibold text-sm",
        buttonType: BUTTON_TYPES.TEXT_BUTTON,
        disabled: disableEditInDependency,
        hidden: dependencyEditMode,
      },
      {
        name: t("Update"),
        id: "update",
        prefixIconTemplate: <UpdateIcon />,
        cssClass: "font-semibold text-sm",
        buttonType: BUTTON_TYPES.TEXT_BUTTON,
        hidden: !dependencyEditMode,
      },
      {
        name: t("Delete"),
        id: "delete",
        prefixIcon: "delete",
        cssClass: "font-semibold text-sm",
        buttonType: BUTTON_TYPES.TEXT_BUTTON,
        disabled: disableDeleteInDependency,
        hidden: dependencyEditMode,
      },
      {
        name: t("Cancel"),
        id: "cancel",
        prefixIconTemplate: <CancelIcon />,
        cssClass: "font-semibold text-sm",
        buttonType: BUTTON_TYPES.TEXT_BUTTON,
        hidden: !dependencyEditMode,
      },
    ],
    [disableAddInDependency, dependencyEditMode, disableEditInDependency, disableDeleteInDependency],
  );
  const toolbarClickHandler = (args: string) => {
    if (args == "add") {
      handleAddClick();
    } else if (args == "edit") {
      handleEditClick();
    } else if (args == "update") {
      handleUpdateClick();
    } else if (args == "delete") {
      handleDeleteClick();
    } else if (args == "cancel") {
      handleCancelClick();
    }
  };

  const handleRowSelection = () => {
    if (reactGridRef.current) {
      const selectedRows = reactGridRef.current.slickGrid.getSelectedRows();
      setDisableEditInDependency(selectedRows.length !== 1);
      setDisableDeleteInDependency(selectedRows.length < 1);
      setDisableAddInDependency(selectedRows.length > 0);
    }
  };

  const getDependencySlickGrid = () => (
    <div className="flex flex-col overflow-auto h-full ps-3 pe-3 pb-3">
      <SlickGrid1
        toolbar={toolbar}
        toolbarClickHandler={toolbarClickHandler}
        ref={reactGridRef}
        columnDefinitions={gridColumns as any}
        gridOptions={slickGridOptions}
        dataset={dependencyDataset}
        isEditMode={dependencyEditMode}
        onSelectedRowIdsChanged={handleRowSelection}
      />
    </div>
  );

  return getDependencySlickGrid();
}

export default DependencyInGantt;
